const contact = {
    title: 'Contact Us',
    subtitle: 'We are here to help you plan your perfect experience in Abruzzo',
    companyInformation: 'Company Information',
    authenticExperiences: 'Authentic experiences in Abruzzo',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    vatNumber: 'VAT Number',
    openingHours: 'Opening Hours',
    mondayFriday: 'Monday - Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closed: 'Closed',
    sendRequest: 'Send a Request',
    nameLabel: 'Name *',
    subjectLabel: 'Subject *',
    emailLabel: 'Email *',
    phoneLabel: 'Phone (optional)',
    phoneOptional: 'Phone (optional)',
    messageLabel: 'Request Description *',
    messagePlaceholder: 'Describe your request, questions, or special requests...',
    namePlaceholder: 'Your name',
    emailPlaceholder: 'your-email@example.com',
    subjectPlaceholder: 'Message subject',
    submitButton: 'Send Request',
    submitting: 'Sending...',
    successMessage: 'Thank you! Your request has been sent successfully. We will respond soon.',
    errorMessage: 'An error occurred. Please try again later.',
    charactersRemaining: 'characters remaining',
    charactersLeft: 'characters left',
    nameInvalidChars: 'Name can only contain letters, spaces, hyphens, and apostrophes',
    subjectInvalidChars: 'Subject can only contain letters, numbers, spaces, and basic punctuation'
};

export default contact;
